import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class ProjectTaskSearchResultDto {
    communityId: number;
    community: string;
    location: string;
    taskId: number;
    taskDescription: string;
    notes: string;

    @Type(() => UserNameDisplayResultDto)
    responsible: UserNameDisplayResultDto;

    status: string;
    noteId: number;

    @Type(() => Date)
    dueDate: Date;

    hasItemNotes: boolean;

    // transient variable
    showDescription = false;

    get responsibleDisplayText(): string {
        return Utils.notNullAndDefined(this.responsible) ? this.responsible.displayName : '';
    }
}
